<div class="button-menu">
    @if (includeExports) {
        <div class="dropdown-wrapper" appMousedownOutside (mousedownOutside)="showExportOptions = false">
            @if (inPresentationMode && userCanExport) {
                <cc-icon
                    class="export-icon"
                    title="Export"
                    [icon]="'logout'"
                    [size]="'medium'"
                    (iconClicked)="toggleExportOptions()"
                />
            }

            <div class="dropdown right-position" [hidden]="!showExportOptions">
                @if (showExportOptions) {
                    <app-dashboard-export
                        [userPreferences]="userPreferences"
                        (exportOptionsClose)="closeDashboardExport()"
                    >
                    </app-dashboard-export>
                }
            </div>
        </div>
    }
</div>
